import { onMounted, computed } from 'vue'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'

export default () => {
    const store = useStore()
    const router = useRouter()
    
    const yoomoneyCardAuthUrl = () => {
      let url = `${process.env.VUE_APP_YOOMONEY_CARDAUTH_URL}?userId=${store.getters.userProfile._id}`
      return url
    }

    const removeCard = (cardId) => {
      store.dispatch('DELuserCard', cardId)
    }

    onMounted(store.dispatch('FETCHuserCards'))

    return {
      userCards: computed(() => store.getters.userCards),
      yoomoneyCardAuthUrl,
      removeCard
  }
}
